export type TableSortDirection = 'asc' | 'desc';

export interface TableSortState<TSortField extends string> {
    direction: TableSortDirection | null;
    sort: TSortField | null;
}

interface GetNextTableSortStateParams<TSortField extends string>
    extends TableSortState<TSortField> {
    allowClear: boolean;
    sortField: TSortField;
}

export const getNextTableSortState = <TSortField extends string>({
    allowClear,
    direction,
    sort,
    sortField,
}: GetNextTableSortStateParams<TSortField>): TableSortState<TSortField> => {
    if (sort !== sortField || direction === null) {
        return { direction: 'asc', sort: sortField };
    }

    if (direction === 'asc') {
        return { direction: 'desc', sort: sortField };
    }

    return allowClear ? { direction: null, sort: null } : { direction: 'asc', sort: sortField };
};
